export default {"headers":{"plural-forms":"nplurals=2; plural=(n != 1);","language":"he-x-NoNikud"},"contexts":{"":{"Korach":["קורח"],"Chukat":["חוקת"]}}}